import React, { createContext, useContext } from 'react';
const UserManagementStatusContext = createContext({
    statusConfig: null,
});
export const UserManagementStatusProvider = ({ statusConfig, children }) => (React.createElement(UserManagementStatusContext.Provider, { value: { statusConfig } }, children));
export const useUserManagementAuthFlags = () => {
    const { statusConfig } = useContext(UserManagementStatusContext);
    return statusConfig?.status?.authentication ?? {};
};
//# sourceMappingURL=user-management-status-context.js.map